// @ts-ignore
import { Button } from '../../css/index.js';
import { FullPageOuter, Heading, Content, ImageWrap, SubHeading } from './styles.js';

function ErrorScreen(props) {
  const {
    children,
    getStatus,
    gettingStatus,
    heading,
    image,
    label,
    subHeading
  } = props;
  return /*#__PURE__*/React.createElement(FullPageOuter, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(ImageWrap, null, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: "problem-with-api"
  })), /*#__PURE__*/React.createElement(Heading, {
    "data-cypress": 'unhealthy-api-heading'
  }, heading), subHeading && /*#__PURE__*/React.createElement(SubHeading, {
    "data-cypress": 'unhealthy-api-subheading'
  }, subHeading), getStatus && /*#__PURE__*/React.createElement(Button, {
    onClick: getStatus,
    loading: gettingStatus
  }, label), children));
}

export default ErrorScreen;